export const TENANT_TYPES = {
    private: "Person",
    organization: "Organization",
};

export const RESIDENCE_TYPES = [
    { value: "GARAGE", displayName: "Garage" },
    { value: "OFFICE", displayName: "Office" },
    { value: "ATELIER", displayName: "Atelier" },
    { value: "SEWING_WORKSHOP", displayName: "Sewing workshop" },
    { value: "CAR_WORKSHOP", displayName: "Car workshop" },
    { value: "MASSAGE_WORKSHOP", displayName: "Massage workshop" },
    { value: "PRODUCTION_HALL", displayName: "Production hall" },
];

export const BATHROOM_TYPES = [
    { value: "PRIVATE", displayName: "Private" },
    { value: "SHARED", displayName: "Shared" },
];

export const LOCATION_TAGS = [
    { value: "TECH_CENTER", displayName: "Tech center" },
    { value: "STARTUP_CENTER", displayName: "Startup center" },
];

export const PARKING_TYPES = [
    { value: "HALL", displayName: "Hall" },
    { value: "OUTDOORS", displayName: "Outdoors" },
    { value: "STREET", displayName: "Street" },
];


export const RESPONSIBILITY_FACTORS = [
    { value: "RENEWABLE_ENERGY", displayName: "Renewable energy" },
    { value: "DISTRICT_HEATING", displayName: "District heating" },
    { value: "GEOTHERMAL_HEATING", displayName: "Geothermal heating" },
];

export const PROPERTIES_TOGGLES = {
    SIZE: {
        meetingRoom: "Meeting room",
        kitchen: "Kitchen",
        cookingSpace: "Cooking space",
        breakRoom: "Break Room",
        looseWorkstation: "Loose workstations",
        waterTap: "Water Tap",
        lighting: "Lighting",
        naturalLight: "Natural Light",
    },
    RENT: {
        rentCoversElectricity: "Electricity",
        rentCoversWater: "Water",
        rentCoversWasteDisposal: "Waste disposal",
    },
    LOCATION: {
        cityCenter: "City center",
        safeArea: "Safe area",
        trainStationNearby: "Train station",
        metroNearby: "Metro",
        tramNearby: "Tram",
        airportTransportNearby: "Airport transport",
        parkNearby: "Park",
        hotelNearby: "Hotel",
        lunchNearby: "Lunch",
        mallNearby: "Mall",
    },
    BUILDING: {
        lobbyServices: "Lobby services",
        electricCarChargingStation: "Electric car charging",
        accessible24h: "Accessible 24h",
        phoneBooth: "Phone Booth",
        gym: "Gym",
        showers: "Showers",
        temperatureAdjustment: "Temperature Control",
        highSpeedInternet: "High speed internet",
        bikeStorage: "Bike storage",
        accessibilityForDisabled: "Accessibility for disabled",
        parkHallSurveillance: "Parking hall surveillance",
        videoConferenceRoom: "Video conference room",
        lounge: "Lounge",
        restaurant: "Restaurant",
        canteen: "Canteen",
        cafeteria: "Cafeteria",
        cameraSurveillance24h: "Camera surveillance 24h",
        coldStorage: "Cold storage",
        crane: "Crane",
        driveIn: "Drive-in Possible",
        controlRoom24h: "24/7 Control Room",
        buildingInsurance: "Building Insurance Included",
        smartLock: "Smart Lock (Exterior)",
    },
};

export const PROPERTIES_FIELDS = {
    ARRAY_MATCH: [
        "residenceType",
        "wc",
        "locationTags",
        "parking",
        "responsibilityFactors",
    ],
    SMALLER_BETTER: ["rent", "deposit", "airportDistance"],
    LARGER_BETTER: [
        "size",
        "terminationPeriodMonths",
        "elevatorWidthMeters",
        "elevatorHeightMeters",
        "loadingDockWidthMeters",
        "loadingDockDepthMeters",
    ],
    BOOLEAN_FIELDS: [
        "meetingRoom",
        "kitchen",
        "cookingSpace",
        "breakRoom",
        "looseWorkstation",
        "rentCoversElectricity",
        "rentCoversWater",
        "rentCoversWasteDisposal",
        "cityCenter",
        "trainStationNearby",
        "metroNearby",
        "tramNearby",
        "airportTransportNearby",
        "parkNearby",
        "hotelNearby",
        "lunchNearby",
        "safeArea",
        "mallNearby",
        "elevator",
        "lobbyServices",
        "electricCarChargingStation",
        "accessible24h",
        "phoneBooth",
        "gym",
        "showers",
        "temperatureAdjustment",
        "highSpeedInternet",
        "bikeStorage",
        "accessibilityForDisabled",
        "parkHallSurveillance",
        "videoConferenceRoom",
        "lounge",
        "restaurant",
        "canteen",
        "cafeteria",
        "cameraSurveillance24h",
        "coldStorage",
        "crane",
        "loadingDock",
        "waterTap",
        "lighting",
        "naturalLight",
        "driveIn",
        "controlRoom24h",
        "buildingInsurance",
        "smartLock",
    ],
    // Not implemented for search, as it might not be necessary
    RANGE_FIELDS: [
        ["whenAvailable", "moveOutDate"],
        ["minRentDurationMonths", "maxRentDurationMonths"],
    ],
};
